import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDevices } from '../../services/DeviceService';
import { DevicesResponse } from '../../types/Devices';
import { FeaturesManagement } from '../../../featuresControl';

function useGetDevices(fleetId: string, query: string, enabled: boolean = true): UseQueryResult<DevicesResponse> {
  return useQuery(
    ['devices', fleetId, query],
    async (): Promise<DevicesResponse> => getDevices(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      enabled,
    },
  );
}

export default useGetDevices;
